const topAnime2 = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    // gsap.set(".main-txt", {
    //   opacity: 0,
    //   scale: 1.2,
    // });
    // gsap.set(".light", {
    //   // opacity: 0,
    // });
    // gsap.set(".appear", {
    //   opacity: 0,
    // });

    // var mainAnime2 = gsap.timeline({});

    // mainAnime2.to(".front-light", {
    //   duration: 0.6,
    //   delay: 0.8,
    //   // ease: "power3.in",
    //   ease: "expo.inOut",
    //   clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    // });

    // mainAnime2.to(".side-light", {
    //   ease: "expo.inOut",
    //   duration: 0.6,
    //   clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    // });

    // mainAnime2.to(".vertical-light", {
    //   ease: "expo.inOut",
    //   duration: 0.6,
    //   clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    // });

    // mainAnime2.to(".appear", {
    //   opacity: 1,
    //   duration: 1,
    //   ease:"sine.inOut",
    // });

    // mainAnime2.to(".main-txt", {
    //   scale:1,
    //   opacity: 1,
    //   duration: 1.4,
    //   ease:"sine.out",
    // });


    function handleScroll() {
      const header = document.querySelector(".header");
      if (window.scrollY > 300) {
          header.classList.add("show");
      } 
      // else {
      //     header.classList.remove("show");
      // }
  }

  // スクロールイベントをウィンドウに追加
  window.addEventListener("scroll", handleScroll);


    // ----------------------room-------------------------


  }
})();
export default topAnime2;